import { useId } from 'react'

type MavolyraLogoProps = {
  className?: string
  showAdminLabel?: boolean
  title?: string
  variant?: 'default' | 'public'
}

export const MavolyraLogo = ({
  className = 'brand-logo',
  showAdminLabel = false,
  title = showAdminLabel ? 'Mavolyra Admin' : 'Mavolyra',
  variant = 'default'
}: MavolyraLogoProps) => {
  const gradientId = `${useId().replace(/:/g, '')}-ripple`

  if (variant === 'public') {
    return (
      <svg
        className={className}
        viewBox="0 0 188 48"
        role="img"
        aria-label={title}
      >
        <defs>
          <linearGradient id={gradientId} x1="9" y1="9" x2="39" y2="39" gradientUnits="userSpaceOnUse">
            <stop stopColor="#4f7294" />
            <stop offset="1" stopColor="#86b9a7" />
          </linearGradient>
        </defs>
        <g className="brand-logo-mark public-brand-logo-mark">
          <circle cx="24" cy="24" r="17.5" fill="#fff" opacity="0.42" />
          <circle cx="24" cy="24" r="17" fill="none" stroke="#d7e4e0" strokeWidth="1.2" />
          <circle cx="24" cy="24" r="11.5" fill="none" stroke={`url(#${gradientId})`} strokeWidth="1.8" opacity="0.58" />
          <circle cx="24" cy="24" r="7.2" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2.4" opacity="0.9" />
          <circle cx="24" cy="24" r="3.7" fill={`url(#${gradientId})`} />
          <path d="M22.8 20.8v6.4l4.8-3.2Z" fill="#fff" />
        </g>
        <text className="brand-logo-name public-brand-logo-name" x="58" y="31">
          Mavolyra
        </text>
      </svg>
    )
  }

  return (
    <svg
      className={className}
      viewBox="0 0 250 72"
      role="img"
      aria-label={title}
    >
      <defs>
        <linearGradient id={gradientId} x1="12" y1="12" x2="60" y2="60" gradientUnits="userSpaceOnUse">
          <stop stopColor="#4f7294" />
          <stop offset="1" stopColor="#86b9a7" />
        </linearGradient>
      </defs>
      <g className="brand-logo-mark">
        <circle cx="36" cy="36" r="28" fill="#eef4f3" />
        <circle cx="36" cy="36" r="20" fill="none" stroke={`url(#${gradientId})`} strokeWidth="2" opacity="0.4" />
        <circle cx="36" cy="36" r="14" fill="none" stroke={`url(#${gradientId})`} strokeWidth="3" opacity="0.7" />
        <circle cx="36" cy="36" r="8" fill={`url(#${gradientId})`} />
        <path d="M34 32v8l6-4Z" fill="#fff" />
      </g>
      <text className="brand-logo-name" x="82" y="39">
        Mavolyra
      </text>
      {showAdminLabel && (
        <text className="brand-logo-admin" x="84" y="54">
          ADMIN
        </text>
      )}
    </svg>
  )
}
